var map = {
	"./about/woman-high-five.jpg": 49212,
	"./account/morning-routine.jpg": 25017,
	"./account/weighing-scale.jpg": 67753,
	"./account/william-tell.jpg": 67177,
	"./agenda/log-book.jpg": 72725,
	"./food/food-picture.jpg": 20528,
	"./food/nutrition-facts.jpg": 38431,
	"./food/salting-food.jpg": 96528,
	"./foodItem/grocery-shopping.jpg": 14364,
	"./libra/tarot/1.jpg": 10025,
	"./libra/tarot/10.jpg": 78869,
	"./libra/tarot/11.jpg": 71000,
	"./libra/tarot/12.jpg": 24807,
	"./libra/tarot/13.jpg": 52618,
	"./libra/tarot/14.jpg": 23513,
	"./libra/tarot/15.jpg": 2460,
	"./libra/tarot/16.jpg": 94443,
	"./libra/tarot/17.jpg": 16398,
	"./libra/tarot/18.jpg": 31405,
	"./libra/tarot/19.jpg": 62832,
	"./libra/tarot/2.jpg": 36318,
	"./libra/tarot/20.jpg": 25348,
	"./libra/tarot/21.jpg": 3393,
	"./libra/tarot/22.jpg": 13814,
	"./libra/tarot/3.jpg": 7451,
	"./libra/tarot/4.jpg": 84776,
	"./libra/tarot/5.jpg": 47141,
	"./libra/tarot/6.jpg": 24538,
	"./libra/tarot/7.jpg": 18999,
	"./libra/tarot/8.jpg": 21284,
	"./libra/tarot/9.jpg": 15681,
	"./library/library-catalogue.jpg": 10615,
	"./recipe/family-baking.jpg": 93868,
	"./recipe/food-prep.jpg": 62331,
	"./standardFood/food-stall.jpg": 9065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26071;